import React from "react";

export default function GreyHoundRacing() {
  return (
    <app-horse-racing _ngcontent-ng-c3019720824="" _nghost-ng-c1578363210="">
      <div _ngcontent-ng-c1578363210="">
        {/**/}
        {/**/}
        {/**/}
        <div
          _ngcontent-ng-c1578363210=""
          className="racing-tab hidden-xs homeevent"
          style={{ background: "#fff" }}
        >
          <div _ngcontent-ng-c1578363210="" className="row">
            <div _ngcontent-ng-c1578363210="" className="col-md-12">
              <div _ngcontent-ng-c1578363210="" className="horse-schedule">
                <h5 _ngcontent-ng-c1578363210="">Greyhound Racing Schedule</h5>
              </div>
            </div>
            <div
              _ngcontent-ng-c1578363210=""
              className="col-md-12 mobile-width"
            />
          </div>
          <div _ngcontent-ng-c1578363210="" className="ng-star-inserted">
            <ul
              _ngcontent-ng-c1578363210=""
              className="nav nav-tabs scrollflags"
            >
              <li _ngcontent-ng-c1578363210="" className="nav-item active">
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center align-items-center active"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <span _ngcontent-ng-c1578363210="">ALL</span>
                </a>
              </li>
              <li
                _ngcontent-ng-c1578363210=""
                className="nav-item ng-star-inserted"
              >
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center flex-column align-items-center"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <img
                    _ngcontent-ng-c1578363210=""
                    className="country-flag"
                    src="https://arrow444.com/assets/flags/GB.svg"
                  />
                  <span _ngcontent-ng-c1578363210="">GB</span>
                </a>
              </li>
              {/**/}
            </ul>
            {/**/}
            <div
              _ngcontent-ng-c1578363210=""
              className="matchList allmarkets ng-star-inserted"
            >
              {/**/}
              <div
                _ngcontent-ng-c1578363210=""
                className="tab-pane tab-pane-con ng-star-inserted"
              >
                <table
                  _ngcontent-ng-c1578363210=""
                  id="gameContainer"
                  className="table table-hover"
                >
                  <tbody _ngcontent-ng-c1578363210="">
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564934395/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:31{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564934395"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256497881/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:34{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256497881"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256505546/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:39{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256505546"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564935635/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:48{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564935635"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256499766/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:51{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256499766"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256507427/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:57{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256507427"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564938635/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:04{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564938635"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564911315/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:08{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564911315"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256508905/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:13{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256508905"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564940395/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:22{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564940395"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564912810/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564912810"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565010545/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:31{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565010545"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564942196/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:39{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564942196"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564914955/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:42{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564914955"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565012265/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:48{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565012265"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564943680/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564943680"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564916555/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:59{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564916555"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565014465/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:04{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565014465"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564945303/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:12{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564945303"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256491835/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:16{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256491835"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565015986/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:21{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565015986"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564946698/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564946698"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564921596/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:33{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564921596"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565017945/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:38{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565017945"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564948630/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:47{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564948630"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/4339002024925649230/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:49{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 4339002024925649230"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565019865/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565019865"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564950251/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:03{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564950251"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564924515/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:07{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564924515"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565021625/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:12{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565021625"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564951695/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:21{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564951695"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564925961/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564925961"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565031239/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:27{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565031239"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565023168/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565023168"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564953375/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Monmore</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:37{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564953375"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492564927675/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:41{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492564927675"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/4339002024925650258/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Nottingham </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:44{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 4339002024925650258"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256503344/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:46{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256503344"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256519140/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:53{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256519140"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565416774/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565416774"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565136202/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:59{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565136202"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565034828/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:03{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565034828"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/4339002024925651591/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:06{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 4339002024925651591"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565110744/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:11{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565110744"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565421813/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:14{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565421813"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565137640/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:18{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565137640"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565036323/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:22{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565036323"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256520360/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256520360"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565112300/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:31{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565112300"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565423773/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:33{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565423773"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565139205/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:37{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565139205"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565038628/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:41{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565038628"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/4339002024925652281/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:43{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 4339002024925652281"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565113465/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:49{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565113465"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565425783/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:52{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565425783"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565140520/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565140520"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256504049/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:59{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256504049"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256523400/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:02{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256523400"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565114820/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:08{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565114820"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565427229/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:11{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565427229"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565141801/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:14{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565141801"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565041443/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:19{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565041443"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256524881/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:21{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256524881"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565116250/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:27{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565116250"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565428613/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565428613"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565144161/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:33{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565144161"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565043284/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:37{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565043284"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256526400/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:39{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256526400"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565117940/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:46{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565117940"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565430524/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:48{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565430524"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565145571/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:52{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565145571"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565044643/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565044643"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565286/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:58{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565286"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565119381/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:04{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565119381"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565431973/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:07{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565431973"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565147285/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:11{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565147285"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565045963/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:14{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565045963"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256529360/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:17{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256529360"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565120940/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:23{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565120940"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565433303/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:26{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565433303"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565148720/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565148720"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565047723/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:33{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565047723"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565211241/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:36{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565211241"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565122700/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:42{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565122700"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565434893/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Oxford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:44{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565434893"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565150445/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:48{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565150445"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565049204/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:51{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565049204"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565212640/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:54{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565212640"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565124180/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:01{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565124180"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565151801/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:07{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565151801"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565052283/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:09{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565052283"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565214120/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:13{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565214120"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565125536/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Hove</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:19{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565125536"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565053698/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Towcester </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565053698"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565153565/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Newcastle </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:26{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565153565"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565215680/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Sunderland </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:32{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565215680"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565228216/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:38{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565228216"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565449746/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:41{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565449746"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565256345/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:44{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565256345"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565229556/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565229556"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565451701/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:59{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565451701"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565258386/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:01{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565258386"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565319914/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:07{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565319914"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565230955/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:12{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565230955"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565453107/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:16{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565453107"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565259830/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:18{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565259830"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565321274/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:23{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565321274"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565232275/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565232275"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565454701/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:34{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565454701"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256531425/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:36{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256531425"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565324193/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:41{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565324193"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565233815/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:46{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565233815"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256532706/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:52{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256532706"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565455941/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:54{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565455941"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565325753/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:57{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565325753"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565235515/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:03{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565235515"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256534386/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:09{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256534386"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565457356/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:12{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565457356"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565327188/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:14{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565327188"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565236796/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:19{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565236796"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256535786/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:26{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256535786"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565458821/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:28{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565458821"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565328673/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:31{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565328673"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565238276/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:37{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565238276"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256537991/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:43{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256537991"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256550781/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:46{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256550781"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565329873/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:49{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565329873"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565239835/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:54{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565239835"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256539386/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:01{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256539386"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256552306/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:04{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256552306"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565331473/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:06{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565331473"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565241595/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:11{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565241595"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565311225/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:17{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565311225"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/43390020249256553701/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Harlow </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:22{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 43390020249256553701"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565332993/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565332993"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565242955/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565242955"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565312711/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:34{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565312711"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565334673/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:41{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565334673"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565244516/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Perry Barr</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:46{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565244516"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565314165/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Yarmouth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:53{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565314165"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565336113/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:58{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565336113"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/433900202492565337553/4339"
                        >
                          <span _ngcontent-ng-c1578363210="">Romford </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:16{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 433900202492565337553"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    {/**/}
                  </tbody>
                </table>
              </div>
              {/**/}
            </div>
            {/**/}
          </div>
          {/**/}
          {/**/}
        </div>
      </div>
    </app-horse-racing>
  );
}
